import ColorCurve from '@/assets/js/ColorCurve';

export default  class SmartCurves {
	constructor() {
		this.blockName = "smartCurve";
		this.templateName = "curve";
		this.canvas = {
			width: 256,
			height: 256,
		};
		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
		this.passNames = ["SmartCurve-Y", "SmartCurve-RGB"];
		this.curveNames = ["SmartCurve-Y", "SmartCurve-R", "SmartCurve-G", "SmartCurve-B"];
		this.testCurveNames = ["smartCurve-Y", "smartCurve-R", "smartCurve-G", "smartCurve-B"];
	}

	async addBlock(blockNum = lutify.blocks.length) {
		UI.createAdjustmentBlockTemplate(this.templateName, blockNum);
		var element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(".btn-reset-block")
			.off("click")
			.on("click", _ => this.resetBlock());
		$(element)
			.find(".curve-selector > span")
			.on("click", e => this.curveSelectorHandler($(element), e.currentTarget));
		$(element)
			.find("canvas")
			.on("mousedown", e => (UI.mouse.down = e.currentTarget));

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		// When moving the point outside the canvas element
		$("#app-view")
			.off("mousemove.smartCurve")
			.on("mousemove.smartCurve", e => {
				// console.log(UI.mouse.down);
				if ($(UI.mouse.down).hasClass("rgbCurves")) {
					let selectCurve = lutify.getActiveBlock().selectedCurve;
					let colorCurve;

					if (selectCurve == "Y") colorCurve = lutify.getActiveBlock().curves[0].colorCurve;
					else if (selectCurve == "R") colorCurve = lutify.getActiveBlock().curves[1].colorCurve;
					else if (selectCurve == "G") colorCurve = lutify.getActiveBlock().curves[2].colorCurve;
					else if (selectCurve == "B") colorCurve = lutify.getActiveBlock().curves[3].colorCurve;

					this.movingPointOutside(e, colorCurve);
				}
			});

		$("#app-view")
			.off("mouseup.smartCurve")
			.on("mouseup.smartCurve", e => {
				if ($(UI.mouse.down).hasClass("rgbCurves")) {
					UI.mouse.down = null;

					let selectCurve = lutify.getActiveBlock().selectedCurve;
					let colorCurve;

					if (selectCurve == "Y") colorCurve = lutify.getActiveBlock().curves[0].colorCurve;
					else if (selectCurve == "R") colorCurve = lutify.getActiveBlock().curves[1].colorCurve;
					else if (selectCurve == "G") colorCurve = lutify.getActiveBlock().curves[2].colorCurve;
					else if (selectCurve == "B") colorCurve = lutify.getActiveBlock().curves[3].colorCurve;

					colorCurve.mouseUp();
					colorCurve.updateValues();
					colorCurve.draw();
				}
			});

		blocks.add({
			name: "smartCurves",
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			passes: this.addPasses(),
			opacity: 100,
			curves: [],
			testCurves: [],
			values: [
				[
					{ x: 0, y: 0 },
					{ x: 1, y: 1 },
				],
				[
					{ x: 0, y: 0 },
					{ x: 1, y: 1 },
				],
				[
					{ x: 0, y: 0 },
					{ x: 1, y: 1 },
				],
				[
					{ x: 0, y: 0 },
					{ x: 1, y: 1 },
				],
			],
			selectedCurve: "Y",
			selectedCurveIndex: 0,
		});

		await new Promise(resolve => {
			const interval = setInterval(() => {
				clearInterval(interval);
				resolve()
			}, 50)
		})

		this.updateCanvsesSize($(element));
		this.updateTemplateCanvases($(element).find("canvas.rgbCurves"), blockNum);
		this.updateBlockCurvesData($(element).find("canvas.rgbCurves"));

		// create testing curves
		// if (config.testCurves.smartCurve) blocks.createCurves(this.testCurveNames, blockNum, true, true);

		this.drawGrid($(element).find('canvas.smart-curve-grid'));
		await this.initColorCurves($(element).find("canvas.rgbCurves"), blockNum);

		// Average mode
		$(element).find(`.blending-mode__items-container > span[data-id="22"]`).trigger("click");
	}

	updateCanvsesSize($element) {

		const availableSpace = $element.find('.canvas-container').width();

		this.canvas.width = availableSpace;
		this.canvas.height = availableSpace;

		$.each($element.find("canvas"), (i, canvas) => {
			$(canvas).attr("width", this.canvas.width);
			$(canvas).attr("height", this.canvas.height);
		});
	}

	drawGrid($canvas) {
		let space = this.canvas.width / 4.0;
		let ctx = $canvas[0].getContext('2d');

		ctx.beginPath();
		ctx.lineWidth = 1;
		ctx.strokeStyle = '#1a1a1a';

		for (let i = 0; i < this.canvas.height - space; i += space) {
			ctx.moveTo(0, i + space); ctx.lineTo(this.canvas.height, i + space);
		}
		for (let i = 0; i < this.canvas.height - space; i += space) {
			ctx.moveTo(i + space, 0); ctx.lineTo(i + space, this.canvas.height);
		}

		ctx.stroke();
	}

	updateTemplateCanvases($canvases, blockNum) {
		$.each($canvases, (i, canvas) => {
			$(canvas).attr("data-id", `${this.curveNames[i]}-${blockNum - config.endFixedPasses}`);
		});
	}

	updateBlockCurvesData($canvases) {
		$.each($canvases, (i, canvas) => {
			let data = {
				name: $(canvas).data("id"),
				colorCurve: null,
			};
			lutify.getActiveBlock().curves[i] = data;
		});
	}

	addPasses() {
		let passes = [];
		this.passNames.forEach(passName => {
			let shaderPass = gpu.createCurveShaderPass(passName);
			gpu.addPassToComposer(shaderPass, "toMiddle");
			passes.push(shaderPass);
		});

		return passes;
	}

	curveSelectorHandler($block, el) {
		$block.find("canvas.--top").removeClass("--top");
		$block.find(`canvas[data-curve="${el.dataset.curve}"]`).addClass("--top");

		lutify.getActiveBlock().selectedCurve = el.dataset.curve;
		lutify.getActiveBlock().selectedCurveIndex = el.dataset.curveIndex;
		this.drawRGBCurves();
	}

	drawRGBCurves() {
		lutify.getActiveBlock().curves.forEach((curve, i) => {
			if (i != lutify.getActiveBlock().selectedCurveIndex) curve.colorCurve.draw(false);
			else curve.colorCurve.draw();
		});
	}

	movingPointOutside(event, colorCurve) {
		// console.log('blockpoints', colorCurve.blockPoint);
		if (colorCurve.currentPoint != -1) {
			let $canvasEl = $(colorCurve.ctx.canvas);
			let offsetLeft = $canvasEl.offset().left;
			let offsetTop = $canvasEl.offset().top;
			let x = (event.pageX - $canvasEl.offset().left) / colorCurve.width;
			let y = (event.pageY - $canvasEl.offset().top) / colorCurve.height;
			let updateCurve = false;

			// if ( ! colorCurve.blockPoint) {
			// LEFT AND RIGHT OF CANVAS
			if (UI.mouse.x < offsetLeft || UI.mouse.x > offsetLeft + colorCurve.width) {
				colorCurve.points[colorCurve.currentPoint].y = 1.0 - y;

				if (colorCurve.points[colorCurve.currentPoint].x < 0.1) colorCurve.points[colorCurve.currentPoint].x = 0;
				else colorCurve.points[colorCurve.currentPoint].x = 1.0;
				updateCurve = true;
			}

			// UP AND DOWN OF CANVAS
			else if (UI.mouse.y < offsetTop || UI.mouse.y > offsetTop + colorCurve.height) {
				colorCurve.points[colorCurve.currentPoint].x = x;

				if (colorCurve.points[colorCurve.currentPoint].y < 0.1) colorCurve.points[colorCurve.currentPoint].y = 0;
				else colorCurve.points[colorCurve.currentPoint].y = 1.0;
				updateCurve = true;
			}

			// PREVENTING POINT TO GO OUTSIDE THE FRAME
			if (colorCurve.points[colorCurve.currentPoint].x > 1.0) colorCurve.points[colorCurve.currentPoint].x = 1.0;
			if (colorCurve.points[colorCurve.currentPoint].x < 0) colorCurve.points[colorCurve.currentPoint].x = 0;

			if (colorCurve.points[colorCurve.currentPoint].y > 1.0) colorCurve.points[colorCurve.currentPoint].y = 1.0;
			if (colorCurve.points[colorCurve.currentPoint].y < 0) colorCurve.points[colorCurve.currentPoint].y = 0;

			// if (typeof colorCurve.points[colorCurve.currentPoint - 1] !== 'undefined') {
			//     if (colorCurve.points[colorCurve.currentPoint - 1].x > colorCurve.points[colorCurve.currentPoint].x) {
			//         colorCurve.points[colorCurve.currentPoint].x = colorCurve.points[colorCurve.currentPoint - 1].x;
			//     }
			// }

			// if (typeof colorCurve.points[colorCurve.currentPoint + 1] !== 'undefined') {
			//     if (colorCurve.points[colorCurve.currentPoint + 1].x < colorCurve.points[colorCurve.currentPoint].x) {
			//         colorCurve.points[colorCurve.currentPoint].x = colorCurve.points[colorCurve.currentPoint + 1].x;
			//     }
			// }
			// }

			if (updateCurve) {
				colorCurve.updateValues();
				colorCurve.draw();
			}
		}
	}

	async initColorCurves($canvases, blockNum) {
		const promises = [];

		$.each($canvases, (i, canvas) => {
			promises.push(
				new Promise(resolve => {
					lutify.getActiveBlock().curves[i].colorCurve = new ColorCurve($(canvas).data("id"), function () {
					}, lutify.getActiveBlock().values[i]);
					lutify.getActiveBlock().curves[i].colorCurve.onChange = () => {
						lutify.activeBlock = parseInt(blockNum);
						blocks.checkSwitchHandler(UI.getActiveBlock());
						this.curveMoveHandler(
							$(canvas)
								.data("id")
								.split("-")[1]
						);

						// if (config.testCurves.smartCurve) {
						//     lutify.getActiveBlock().testCurves[i].colorCurve.points = lutify.getActiveBlock().curves[i].colorCurve.points;
						//     lutify.getActiveBlock().testCurves[i].colorCurve.draw();
						// }
					};

					resolve();
				})
			);
		});

		await Promise.all(promises);
	}

	curveMoveHandler(selectedCurve) {
		if (selectedCurve == "Y") {
			// if we only have 2 points on canvas, make the pass disabled, otherwise enable it
			// if (lutify.getActiveBlock().values[0].length == 2) lutify.getActiveBlock().passes[0].enabled = false;
			// else lutify.getActiveBlock().passes[0].enabled = true;

			lutify.getActiveBlock().passes[0].enabled = true;

			let pointsY = lutify.getActiveBlock().curves[0].colorCurve.rgb;
			this.callGPUCurve(pointsY);
		} else {
			// if we only have 2 points on canvas for R,G and B, make the pass disabled, otherwise enable it
			// if (lutify.getActiveBlock().values[1].length == 2 && lutify.getActiveBlock().values[2].length == 2 && lutify.getActiveBlock().values[3].length == 2) {
			//     lutify.getActiveBlock().passes[1].enabled = false;
			// } else lutify.getActiveBlock().passes[1].enabled = true;

			lutify.getActiveBlock().passes[1].enabled = true;

			let pointsR = lutify.getActiveBlock().curves[1].colorCurve.rgb;
			let pointsG = lutify.getActiveBlock().curves[2].colorCurve.rgb;
			let pointsB = lutify.getActiveBlock().curves[3].colorCurve.rgb;
			this.callGPUCurveRGB(pointsR, pointsG, pointsB);
		}
	}

	callGPUCurve(points) {
		let curveTexture = gpu.pointsToCurve(points);
		lutify.getActiveBlock().passes[0].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	callGPUCurveRGB(pointsR, pointsG, pointsB) {
		let curveTexture = gpu.RGBPointsToCurve(pointsR, pointsG, pointsB);
		lutify.getActiveBlock().passes[1].uniforms["map"].value = curveTexture;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	resetBlock() {
		lutify.getActiveBlock().passes.forEach(pass => (pass.enabled = false));
		lutify.getActiveBlock().curves.forEach((curve, i) => {
			curve.colorCurve.points = [
				{ x: 0, y: 0 },
				{ x: 1, y: 1 },
			];
			curve.colorCurve.draw();
			curve.colorCurve.updateValues();
		});
	}

	async applyChanges($block, curvePoints, blockData) {
		curvePoints.forEach((points, index) => {
			lutify.getActiveBlock().curves[index].colorCurve.points = _.cloneDeep(points);
			lutify.getActiveBlock().values[index] = lutify.getActiveBlock().curves[index].colorCurve.points;

			lutify.getActiveBlock().curves[index].colorCurve.draw();
			lutify.getActiveBlock().curves[index].colorCurve.updateValues();
			lutify.getActiveBlock().curves[index].colorCurve.onChange();
		});

		$block.find('.curve-selector > span[data-curve="Y"]').trigger("click");

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}

		await new Promise(resolve => {
			setTimeout(() => {
				resolve()
			}, 200)
		})
	}
}
